import { OpportunitiesCard, OpportunitiesCardSkeleton } from '@/entities/opportunity';
import { ScrollIntoView } from '@/shared/ui/animations';
import type { CardGridProps } from './CardGrid.types';

export function CardGrid({
  opportunities,
  isLoading,
  onCardClick,
  onToggleFavorite,
  onOpenDetail,
  isNew,
}: CardGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-app-inset">
        {Array.from({ length: 3 }).map((_, i) => (
          <OpportunitiesCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (opportunities.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-app-inset">
      {opportunities.map((opp, index) => (
        <ScrollIntoView key={opp.opportunityId} delay={index * 0.03} variant="slideUp">
          <OpportunitiesCard
            id={opp.opportunityId}
            item={opp}
            isNew={isNew?.(opp)}
            onClick={() => onCardClick(opp)}
            onToggleFavorite={onToggleFavorite}
            onOpenDetail={onOpenDetail}
          />
        </ScrollIntoView>
      ))}
    </div>
  );
}
